import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import OpenChatBot from '~/components/layout/Chatbot';
import Header from '~/components/layout/Header';
import NavigationCard from '~/components/pages/MyAccount/NavigationCard';
import SideBar from '~/components/layout/Sidebar';
import RatingModal from '~/pages/Rating';

import { BiSolidStore } from 'react-icons/bi';
import { AiFillReconciliation } from 'react-icons/ai';

import {
  Container,
  Content,
  HeaderContainer,
  NavigationContainer,
  PageContainer,
} from './styles';
import { fetchNerdMonster } from '../Auth/SingIn';

export default function Marketing() {
  const [loader, setLoader] = useState(false);
  const stores = useSelector(state => state.economicGroupReducer.stores);
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );
  const [showModal, setShowModal] = useState(false);

  const handleClickItem = async (item) => {
    let link = localStorage.getItem(item);
    if (!link) {
      console.error(`No link found for ${item}`);
      return;
    }
    if(item === "googleMeuNegocio") {
      setLoader(true);
      const acessToken = localStorage.getItem('access_token');
      if (!acessToken) {
        console.error('Access token not found');
        return;
      }
      await fetchNerdMonster(acessToken);
      link = localStorage.getItem(item);
    }
    window.open(link, '_blank');
    setLoader(false);
  };

  const hasDisabled = (item) => {
    const link = localStorage.getItem(item);
    return !link || link === '';
  }

  return (
    <PageContainer>

      <SideBar
        menuSelected={'Marketing'}
        hasPendenciOn={classificationReducer.pendenciesOn}
      >
        <Container>
          <RatingModal
            showModal={showModal}
            setShowModal={setShowModal}
            valueRating={0}
            valueComment={''}
          />
          <Content>
            <HeaderContainer>
              <Header stores={stores} />
            </HeaderContainer>
            <NavigationContainer>
              <NavigationCard
                path=""
                title="Materiais de Divulgação"
                icon="barcode.svg"
                customIcon={<AiFillReconciliation size={35} color="#707070" />}
                align="flex-start"
                customClick={() => handleClickItem("jobControl")}
                disabled={hasDisabled("jobControl") || loader}
              />
              <NavigationCard
                path=""
                title="Google Meu Negócio"
                icon="user_perfil.svg"
                customIcon={<BiSolidStore size={35} color="#707070" />}
                align="flex-start"
                customClick={() => handleClickItem("googleMeuNegocio")}
                disabled={hasDisabled("googleMeuNegocio") || loader}
              />
            </NavigationContainer>
          </Content>
        </Container>
        <OpenChatBot />
      </SideBar>
    </PageContainer>
  );
}
